'use client';

import { useResults } from '@liquorice/next-search';
import Box from '../ui/Box';
import Txt from '../ui/Txt';

const SearchSummary = () => {
  const { loading, visibleResults, totalResults } = useResults();

  return (
    <Box cx={{ mT: 'md' }}>
      {loading ? (
        <Txt>Loading...</Txt>
      ) : !!visibleResults ? (
        <Txt>
          Showing {visibleResults} of {totalResults} results
        </Txt>
      ) : (
        <Txt>No results found</Txt>
      )}
    </Box>
  );
};

export default SearchSummary;
